/**
 * System-forms allowlist — the Form Builder's built-in instrument catalog
 * (forms.credifyfast.com app.html `INSTRUMENTS`, keys as of v4.7.1).
 *
 * The Forms Hub must only surface forms that exist in the Form Builder;
 * EHR-seeded forms with no builder counterpart (Patient Demographics,
 * Annual Wellness Survey, Discharge Summary Questionnaire, Treatment Plan
 * Review) are hidden everywhere in the hub. Cross-origin runtime fetch of
 * the builder catalog is blocked today (credifyfbs docs/crm-integration.md
 * CORS allowlist), so the mapping is pinned here.
 */
export const SYSTEM_FORM_MAP: Record<string, string> = {
  'PHQ-9 Depression Screener': 'phq9',
  'GAD-7 Anxiety Screener': 'gad7',
  'PCL-5 Trauma Screen': 'pcl5',
  'AUDIT-C Alcohol Use': 'audit',
  'DAST-10 Drug Use': 'dast10',
  'C-SSRS Suicide Risk': 'cssrs',
  'Intake Assessment': 'intake',
  'Informed Consent for Treatment': 'consent_treatment',
  'Telehealth Consent': 'consent_telehealth',
  'Authorization to Release Info (ROI)': 'roi',
  '42 CFR Part 2 Consent': 'part2_consent',
};

export const isSystemForm = (name: string | null | undefined): boolean =>
  !!name && name in SYSTEM_FORM_MAP;
